// before 20-5-2026

// import React, { useEffect, useState } from 'react';
// import Container from 'react-bootstrap/esm/Container';
// import { useDispatch, useSelector } from 'react-redux';
// import { Notify } from '../../Utility/Notify';
// import {
//   GetOneCommunicationwayData,
//   UpdateOneCommunicationData,
// } from '../../Redux/Actions/CommunicationWay_Action';
// import { Link, useParams } from 'react-router-dom';
// import Row from 'react-bootstrap/esm/Row';
// import SyncAltIcon from '@mui/icons-material/SyncAlt';
// import { Col } from 'react-bootstrap';
// import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
// import { CircularProgress, useTheme } from '@mui/material';

// export const UpdateCommunicationWay = () => {
//   const [updateCommunicationLoading, setUpdateCommunicationLoading] = useState(false);
//   const theme = useTheme();
//   const mode = theme.palette.mode;
//   const [userlogin, setuserlogin] = useState('');
//   useEffect(() => {
//     if (JSON.parse(localStorage.getItem('user')) != null) {
//       setuserlogin(JSON.parse(localStorage.getItem('user')));
//     }
//   }, []);

//   const { id } = useParams();
//   const dispatch = useDispatch();
//   const [communication, setcommunication] = useState('');
//   const [loading, setloading] = useState(true);

//   const communicationnamechange = (e) => {
//     setcommunication(e.target.value);
//   };

//   //get one commution data for updating

//   useEffect(() => {
//     const run = async () => {
//       await dispatch(GetOneCommunicationwayData(id));
//     };
//     run();
//   }, [dispatch]);

//   const res_one_communication = useSelector((state) => state.AllCommunicationway.communicationway);

//   let one_communication = [];

//   if (res_one_communication && res_one_communication.data) {
//     one_communication = res_one_communication.data;
//   } else {
//     one_communication = [];
//   }

//   useEffect(() => {
//     if (one_communication) {
//       setcommunication(one_communication.name);
//     }
//   }, [one_communication]);

//   //update button ==>communication way
//   const onsubmitupdate = async (e) => {
//     e.preventDefault();
//     if (communication === '') {
//       Notify('error', 'Communication Way Name is Required', 'error');
//       return;
//     } else {
//       setloading(true);
//       setUpdateCommunicationLoading(true);

//       await dispatch(
//         UpdateOneCommunicationData(id, {
//           name: communication,
//         }),
//       );
//       setloading(false);
//       setUpdateCommunicationLoading(false);
//     }
//   };
//   const res_update_communication = useSelector(
//     (state) => state.AllCommunicationway.Updatecommunicationway,
//   );

//   // let res_update_array = Array.isArray(res_Add?.data) ? res_Add.data : [];

//   useEffect(() => {
//     if (loading === false) {
//       if (res_update_communication && res_update_communication.status === 200) {
//         Notify('success', 'Updated Successfully', 'success');
//         setcommunication('');
//       } else {
//         Notify('error', 'Failed to Update Communication Way', 'error');
//         setTimeout(() => {
//           window.location.reload(false);
//         }, 1000);
//         return;
//       }
//     }
//   }, [loading]);

//   // تحديد المسار المناسب بناءً على الدور
//   const homeRoute =
//     userlogin?.data?.role === 'Admin'
//       ? '/AllLeadsForAdmin'
//       : userlogin?.data?.role === 'Marketer'
//         ? '/ALLLeadsForMarketer'
//         : '/'; // fallback

//   return (
//     <Container className="startpage">
//       <Row>
//         <Col sm={2}></Col>
//         <Col sm={10}>
//           {/* <div className='mx-4 d-flex'>
//                 <div className='mx-3'>Update Communication Way</div>
//                 <a style={{textDecoration:'none'}} href='/Communicationway' className='goback'>{"<<"} Go To Communication Way </a>
//             </div> */}
//           <div className="d-flex">
//             <div>
//               <Link to={homeRoute} style={{ textDecoration: 'none', color: '#102dff' }}>
//                 <span style={{ fontWeight: 'bold' }}>Home</span>
//               </Link>

//               <KeyboardDoubleArrowRightIcon />

//               <Link
//                 to={`/Communicationway`}
//                 style={{
//                   textDecoration: 'none',
//                   color: '#666',
//                   fontWeight: 'bold',
//                 }}
//               >
//                 <span>Communication Way</span>
//               </Link>

//               <KeyboardDoubleArrowRightIcon />

//               <span style={{ color: '#666' }}>Update Communication Way</span>
//             </div>
//           </div>

//           {/* inputes of add Communication way */}
//           <div
//             style={{
//               padding: '25px',
//               borderRadius: '15px',
//               background: mode === 'dark' ? '#333' : '#fff',
//             }}
//           >
//             <Row>
//               <div>
//                 <label for="Name">Communication Way Name</label>
//                 <input
//                   style={{ background: 'transparent', color: mode === 'dark' ? '#fff' : '#333' }}
//                   onChange={communicationnamechange}
//                   value={communication}
//                   className="inputsaddclient"
//                   type="text"
//                   id="name"
//                   name="Name"
//                   placeholder="Communication Way Name.."
//                 />
//               </div>
//             </Row>

//             <Row
//               className="d-flex justify-content-center mx-1"
//               style={{ width: '100%', marginTop: '15px', textAlign: 'center' }}
//             >
//               {/* <div onClick={onsubmitupdate} style={{background:'#0F7687'}}  className='addnewclient'  type="submit" ><SyncAltIcon/> Update Communication Way</div> */}
//               <div
//                 onClick={!updateCommunicationLoading ? onsubmitupdate : null}
//                 className="addnewclient"
//                 style={{
//                   background: '#102dff',
//                   pointerEvents: updateCommunicationLoading ? 'none' : 'auto',
//                   opacity: updateCommunicationLoading ? 0.6 : 1,
//                   cursor: updateCommunicationLoading ? 'not-allowed' : 'pointer',
//                   textAlign: 'center',
//                 }}
//                 type="submit"
//               >
//                 {updateCommunicationLoading ? (
//                   <CircularProgress size={20} style={{ color: 'white' }} />
//                 ) : (
//                   <>
//                     <SyncAltIcon /> Update Communication Way
//                   </>
//                 )}
//               </div>
//             </Row>
//           </div>
//         </Col>
//       </Row>
//     </Container>
//   );
// };























// 20-5-2026
import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTheme } from '@mui/material/styles';
import { CircularProgress } from '@mui/material';
import SyncAltIcon from '@mui/icons-material/SyncAlt';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import {
  GetOneCommunicationwayData,
  UpdateOneCommunicationData,
} from '../../Redux/Actions/CommunicationWay_Action';
import { Notify } from '../../Utility/Notify';
import { useSidebarWidth } from '../../Utility/useSidebarWidth';

export const UpdateCommunicationWay = () => {
  const theme = useTheme();
  const isDark = theme.palette.mode === 'dark';
  const navigate = useNavigate();
  const sidebarWidth = useSidebarWidth();
  const { id } = useParams();
  const dispatch = useDispatch();

  const [updateCommunicationLoading, setUpdateCommunicationLoading] = useState(false);
  const [userlogin, setuserlogin] = useState('');
  const [communication, setCommunication] = useState('');
  const [loading, setloading] = useState(true);
  const [formErrors, setFormErrors] = useState({});

  useEffect(() => {
    if (JSON.parse(localStorage.getItem('user')) != null) {
      setuserlogin(JSON.parse(localStorage.getItem('user')));
    }
  }, []);

  /* ── fetch existing data ── */
  useEffect(() => {
    dispatch(GetOneCommunicationwayData(id));
  }, [dispatch]);

  const res_one_communication = useSelector((state) => state.AllCommunicationway.communicationway);

  useEffect(() => {
    if (res_one_communication?.data) {
      setCommunication(res_one_communication.data.name || '');
    }
  }, [res_one_communication]);

  /* ── validation ── */
  const validate = () => {
    const errors = {};
    if (!communication.trim()) errors.communication = 'Communication Way Name is required';
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  /* ── submit ── */
  const onsubmitupdate = async (e) => {
    e.preventDefault();
    if (!validate()) return Notify('error', 'Please fix form errors', 'error');

    setUpdateCommunicationLoading(true);
    setloading(true);

    await dispatch(UpdateOneCommunicationData(id, { name: communication }));

    setloading(false);
    setUpdateCommunicationLoading(false);
  };

  const res_update_communication = useSelector(
    (state) => state.AllCommunicationway.Updatecommunicationway,
  );

  useEffect(() => {
    if (loading === false) {
      if (res_update_communication && res_update_communication.status === 200) {
        Notify('success', 'Updated Successfully', 'success');
        setFormErrors({});
        setTimeout(() => navigate('/Communicationway'), 1500);
      } else {
        Notify('error', 'Failed to Update Communication Way', 'error');
      }
      setloading(true);
    }
  }, [loading]);

  const homeRoute =
    userlogin?.data?.role === 'Admin'
      ? '/AllLeadsForAdmin'
      : userlogin?.data?.role === 'Marketer'
        ? '/ALLLeadsForMarketer'
        : '/';

  /* ─── shared styles ─── */
  const inputStyle = (hasError) => ({
    width: '100%',
    padding: '13px 16px',
    borderRadius: '10px',
    border: `1.5px solid ${hasError ? '#ef4444' : (isDark ? '#2d3248' : '#e2e8f0')}`,
    backgroundColor: isDark ? '#151827' : '#f8fafc',
    color: isDark ? '#f1f5f9' : '#0f172a',
    fontSize: '14px',
    outline: 'none',
    transition: 'all 0.2s',
    fontFamily: "'DM Sans',sans-serif",
    boxSizing: 'border-box',
  });

  const labelStyle = {
    display: 'block',
    fontSize: '11px',
    fontWeight: 700,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: isDark ? '#9ca3af' : '#64748b',
    marginBottom: '8px',
  };

  const errorStyle = {
    fontSize: '12px',
    color: '#ef4444',
    margin: '5px 0 0',
  };

  const onFocus = (e) => {
    e.target.style.borderColor = '#2563eb';
    e.target.style.backgroundColor = isDark ? '#1a1f35' : '#ffffff';
    e.target.style.boxShadow = '0 0 0 3px rgba(37,99,235,0.12)';
  };

  const onBlur = (e, hasError) => {
    e.target.style.borderColor = hasError ? '#ef4444' : (isDark ? '#2d3248' : '#e2e8f0');
    e.target.style.backgroundColor = isDark ? '#151827' : '#f8fafc';
    e.target.style.boxShadow = 'none';
  };

  return (
    <div style={{
      position: 'fixed',
      top: '50px',
      left: sidebarWidth,
      right: 0,
      bottom: 0,
      transition: 'left 0.25s cubic-bezier(0.4,0,0.2,1)',
      overflowY: 'auto',
      background: isDark ? 'linear-gradient(135deg,#0f1117 0%,#1a1d2e 100%)' : '#f0f2f5',
      fontFamily: "'DM Sans','Segoe UI',sans-serif",
      marginTop: '10px',
    }}>

      {/* ── Breadcrumb ── */}
      <div style={{
        padding: '14px 28px',
        backgroundColor: isDark ? '#1a1d2e' : '#f0f2f5',
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        fontSize: '13px',
      }}>
        <Link
          to={homeRoute}
          style={{ textDecoration: 'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500 }}
        >
          Home
        </Link>
        <KeyboardDoubleArrowRightIcon sx={{ fontSize: 16, color: isDark ? '#4b5563' : '#d1d5db' }} />
        <Link
          to="/Communicationway"
          style={{ textDecoration: 'none', color: isDark ? '#9ca3af' : '#6b7280', fontWeight: 500 }}
        >
          Communication Ways
        </Link>
        <KeyboardDoubleArrowRightIcon sx={{ fontSize: 16, color: isDark ? '#4b5563' : '#d1d5db' }} />
        <span style={{ color: isDark ? '#e5e7eb' : '#111827', fontWeight: 600 }}>
          Update Communication Way
        </span>
      </div>

      {/* ── Form ── */}
      <div style={{ padding: '28px 32px 48px' }}>
        <div style={{
          width: '100%',
          maxWidth: '720px',
          backgroundColor: isDark ? '#1e2132' : '#ffffff',
          borderRadius: '20px',
          padding: '36px 40px',
          boxShadow: isDark ? '0 24px 60px rgba(0,0,0,0.5)' : '0 4px 32px rgba(0,0,0,0.08)',
          border: isDark ? '1px solid #2a2f45' : '1px solid #e8eaf0',
        }}>

          {/* title */}
          <div style={{ marginBottom: '28px' }}>
            <h1 style={{
              fontSize: '22px',
              fontWeight: 700,
              color: isDark ? '#f1f5f9' : '#0d1b3e',
              margin: '0 0 4px',
              letterSpacing: '-0.4px',
            }}>
              Update Communication Way
            </h1>
            <p style={{
              fontSize: '13px',
              color: isDark ? '#6b7280' : '#94a3b8',
              margin: 0,
            }}>
              Edit the communication way details in the CRM system
            </p>
          </div>

          {/* ── Communication Way Name ── */}
          <div style={{ marginBottom: '20px' }}>
            <label style={labelStyle}>Communication Way Name *</label>
            <input
              style={inputStyle(!!formErrors.communication)}
              value={communication}
              onChange={(e) => {
                setCommunication(e.target.value);
                if (formErrors.communication) setFormErrors((p) => ({ ...p, communication: '' }));
              }}
              type="text"
              placeholder="e.g. WhatsApp, Email, Phone Call"
              onFocus={onFocus}
              onBlur={(e) => onBlur(e, !!formErrors.communication)}
              autoFocus
            />
            {formErrors.communication
              ? <p style={errorStyle}>{formErrors.communication}</p>
              : (
                <p style={{ fontSize: '12px', color: isDark ? '#4b5563' : '#94a3b8', margin: '5px 0 0' }}>
                  The name used to identify this communication channel
                </p>
              )
            }
          </div>

          {/* divider */}
          <div style={{
            height: '1px',
            backgroundColor: isDark ? '#2a2f45' : '#e8eaf0',
            margin: '28px 0',
          }} />

          {/* buttons */}
          <div style={{ display: 'flex', gap: '12px' }}>
            <button
              onClick={!updateCommunicationLoading ? onsubmitupdate : null}
              disabled={updateCommunicationLoading}
              type="button"
              style={{
                flex: 1,
                padding: '14px 24px',
                borderRadius: '10px',
                border: 'none',
                background: 'linear-gradient(135deg,#1e3a8a,#1d4ed8)',
                color: '#fff',
                fontSize: '13px',
                fontWeight: 700,
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
                cursor: updateCommunicationLoading ? 'not-allowed' : 'pointer',
                opacity: updateCommunicationLoading ? 0.7 : 1,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '8px',
                transition: 'all 0.2s',
                boxShadow: '0 4px 16px rgba(29,78,216,0.35)',
                fontFamily: "'DM Sans',sans-serif",
              }}
              onMouseEnter={(e) => {
                if (!updateCommunicationLoading) {
                  e.currentTarget.style.transform = 'translateY(-1px)';
                  e.currentTarget.style.boxShadow = '0 6px 24px rgba(29,78,216,0.45)';
                }
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = 'none';
                e.currentTarget.style.boxShadow = '0 4px 16px rgba(29,78,216,0.35)';
              }}
            >
              {updateCommunicationLoading ? (
                <>
                  <CircularProgress size={16} style={{ color: '#fff' }} />
                  <span>Updating...</span>
                </>
              ) : (
                <>
                  <SyncAltIcon sx={{ fontSize: 17 }} />
                  <span>Update Communication Way</span>
                </>
              )}
            </button>

            <button
              type="button"
              onClick={() => navigate('/Communicationway')}
              style={{
                padding: '14px 28px',
                borderRadius: '10px',
                border: `1.5px solid ${isDark ? '#2d3248' : '#e2e8f0'}`,
                backgroundColor: 'transparent',
                color: isDark ? '#9ca3af' : '#64748b',
                fontSize: '13px',
                fontWeight: 700,
                letterSpacing: '0.08em',
                textTransform: 'uppercase',
                cursor: 'pointer',
                transition: 'all 0.2s',
                fontFamily: "'DM Sans',sans-serif",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.borderColor = isDark ? '#4b5563' : '#94a3b8';
                e.currentTarget.style.color = isDark ? '#e5e7eb' : '#374151';
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.borderColor = isDark ? '#2d3248' : '#e2e8f0';
                e.currentTarget.style.color = isDark ? '#9ca3af' : '#64748b';
              }}
            >
              Cancel
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};